import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotification } from '../../Contexts/NotificationContext';
import { usePromptToInstall } from '../../Contexts/PromptToInstallContext';
import { useConfirm } from '../../Contexts/hooks';
import { useConversations, useTheme } from '../../store/hooks';
import UserManagementView from './UserManagementView';



const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...shorthands.flex(1, 1, 'auto'),
        ...shorthands.padding('30px', '120px'),
        ...shorthands.gap('20px'),
        '@media (max-width: 768px)': {
            ...shorthands.padding('20px', '8px'),
        },
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...shorthands.gap('10px'),
    },
    settingsIcon: {
        color: tokens.colorBrandForeground1,
    },
    settingsContent: {
        alignSelf: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap('20px'),
        ...shorthands.margin('2rem', '0', '0', '0'),
        maxWidth: '1000px',
        width: '100%',
    },
    settingsCard: {
        ...shorthands.padding('20px'),
    },
    settingsSection: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap('15px'),
    },
    sectionTitle: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
    },
    sectionDescription: {
        color: tokens.colorNeutralForeground2,
    },
    buttonsContainer: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.gap(tokens.spacingVerticalL),
        marginTop: tokens.spacingVerticalL,
    },
    actionButton:{
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        transition: 'all 0.3s ease-in-out',
        width: '100%',
        height: '48px',
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        '&:hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
        },
        '&:active': {
            backgroundColor: tokens.colorBrandBackgroundPressed,
        },
        '&:disabled': {
            backgroundColor: tokens.colorNeutralBackground4,
            color: tokens.colorNeutralForeground4,
            cursor: 'not-allowed',
        },
    },
    dangerActionButton: {
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        transition: 'all 0.3s ease-in-out',
        width: '100%',
        height: '48px',
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        '&:hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
        },
        '&:active': {
            backgroundColor: tokens.colorBrandBackgroundPressed,
        },    
    },
    
    dividerContainer: {
        ...shorthands.margin(tokens.spacingVerticalM, 0),
    },
    errorText: {
        color: tokens.colorPaletteRedForeground1,
        fontSize: tokens.fontSizeBase200,
    },
});

const UserManagementHandler: FC = () => {
    // Feature flags
    const classes = useStyles();
    const { t } = useTranslation();
    const confirm = useConfirm();
    const { dispatchNotification } = useNotification();
    const { dispatch } = useConversations();
    const { theme, dispatch: themeDispatch } = useTheme();
    const { state, deferredEvt } = usePromptToInstall();
    
// Create a wrapper function for the translation function to match expected signature
    const translationWrapper = (key: string, defaultValue?: string) => {
        return t(key, defaultValue || key);
    };
    
    return (
        <UserManagementView
            classes={classes}
            t={translationWrapper}           
        />
    );
};

export default UserManagementHandler;
